
import { Name } from "../prm/name";
import { RadioButton } from "../prm/radio-button";

const BUTTONS = [
  new Name("accountsReceivable", "Accounts Receivable"),
  new Name("incomeFromEarnings", "Income From Earnings"),
  new Name("legalSettlement", "Legal Settlement"),
  new Name("rollover", "Rollover"),
  new Name("spouseParent", "Spouse/Parent"),
  new Name("accumSavings", "Accumulated Savings"),
  new Name("inheritance", "Inheritance"),
  new Name("lottery", "Lottery/Gaming"),
  new Name("alimony", "Alimony"),
  new Name("insurance", "Insurance Proceeds"),
  new Name("pension", "Pension/IRA/Retirement"),
  new Name("saleBusiness", "Sale of Business"),
  new Name("gift", "Gift"),
  new Name("saleRealEstate", "Sale of Real Estate"),
  new Name("investmentProceeds", "Investment Proceeds"),
  new Name("other", "Other"),
];

const CALC_OTHER_INDEX = () => {
  for(let i=0; i < BUTTONS.length; i++) {
    if (BUTTONS[i].id === "other") {
      return i;
    }
  }
  return -1;
}

const OTHER_INDEX = CALC_OTHER_INDEX();

class SourceOfFundsRadioButton extends RadioButton {
  constructor(name) {
    super(name, BUTTONS);
  }
}

export {
  SourceOfFundsRadioButton, OTHER_INDEX
}